import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class GridCellAuditService {
  GENERAL_CONFIG: any;

  constructor(private http: HttpClient) {
    this.GENERAL_CONFIG = environment;
  }

  getCellAudit(params: any) {
    return this.http.get(this.GENERAL_CONFIG.base_url + '/getCellAudit', {
      params,
    });
  }
}
